import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";

export const ADD_TO_CART = "addToCart";
export const REMOVE_FROM_CART = "removeFromCart";
export const UPDATE_CART = "updateCart";
export const EMPTY_CART = "emptyCart";

export const NOTIFICATION_COUNT = "notificationCount"

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";

export const FRONTEND_PURGE_AUTH = "frontendLogOut";
export const FRONTEND_SET_AUTH = "frontendSetUser";
export const FRONTEND_SET_ERROR = "frontendSetError";

export const SET_NOTIFICATION_COUNT = "setNotificationCount"
export const SET_CART = "setCart"

const state = {
    errors: null,
    user: {},
    isAuthenticated: !!JwtService.getToken(),
    userNotificationCount: "",
    cart: []
};

const getters = {
    currentUser(state) {
        return state.user;
    },
    userRole(state) {
        return state.user.role;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    },
    paginationRows(state) {
        return state.paginationRows;
    },
    paginationRowsVehicles(state) {
        return state.paginationRowsVehicles;
    },
    userNotificationCount(state) {
        return state.userNotificationCount
    },
    userCart(state) {
        return state.cart
    }
};

const actions = {
    [LOGIN](context, credentials) {
        return new Promise(resolve => {
            ApiService.post("admin_login", credentials)
                .then(({ data }) => {
                    if (data.status == "success") {
                        let userData = data.user_data
                        let user = {
                            id: userData.id,
                            first_name: userData.first_name,
                            last_name: userData.last_name,
                            email: userData.email,
                            dob: userData.dob,
                            uid: userData.uid,
                            mobile_no: userData.mobile_no,
                            country_code: userData.country_code,
                            country_dial_code: userData.country_dial_code,
                            address: userData.address,
                            city: userData.city,
                            country: userData.country,
                            postcode: userData.postcode,
                            delivery_address: userData.delivery_address,
                            delivery_city: userData.delivery_city,
                            delivery_country: userData.delivery_country,
                            neswletter_status: userData.neswletter_status,
                            delivery_postcode: userData.delivery_postcode,
                            role: userData.role,
                            profile_photo_path: userData.profile_photo_path,
                            token: data.token,
                            notificationCount: userData.unreadMessage_count
                        }
                        localStorage.setItem('local_products_user_access_role', userData.role);
                        localStorage.setItem('local_products_user_access_id', userData.id);
                        // context.commit(FRONTEND_PURGE_AUTH);
                        context.commit(SET_AUTH, user);
                        resolve({ ...user, login_status: data.status });
                    } else {
                        context.commit(SET_ERROR, data.message);
                        resolve({ login_status: data.status })
                    }
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [LOGOUT](context) {
        ApiService.post("logout")
            .then((response) => {
                const responseJson = response.data;
                if (responseJson.status == "success") {
                    localStorage.setItem("local_products_user_access_token", "");
                    localStorage.setItem('local_products_user_access_role', "");
                    localStorage.setItem('local_products_user_access_id', "");
                    context.commit(PURGE_AUTH);
                }
            })
            .catch(err => {
                localStorage.setItem("local_products_user_access_token", "");
                localStorage.setItem('local_products_user_access_role', "");
                localStorage.setItem('local_products_user_access_id', "");
                context.commit(PURGE_AUTH);
            })
    },
    [VERIFY_AUTH](context) {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            var response = [];
            context.commit(SET_ERROR, response);
        } else {
            context.commit(PURGE_AUTH);
        }
    },
    [UPDATE_USER](context, payload) {
        var token = localStorage.getItem("local_products_user_access_token");
        const { id,
            first_name,
            last_name,
            email,
            dob,
            uid,
            address,
            city,
            postcode,
            country_dial_code,
            country_code,
            delivery_address,
            delivery_city,
            delivery_country,
            delivery_postcode,
            mobile_no,
            country,
            role,
            neswletter_status,
            profile_photo_path } = payload;
        const user = {
            id,
            first_name,
            last_name,
            email,
            dob,
            uid,
            address,
            city,
            postcode,
            country_dial_code,
            country_code,
            delivery_address,
            delivery_city,
            delivery_country,
            delivery_postcode,
            mobile_no,
            country,
            role,
            neswletter_status,
            profile_photo_path,
            token
        }

        context.commit(SET_AUTH, user);
        return user;
    },
    [NOTIFICATION_COUNT](context, payload) {
        const { count } = payload;

        context.commit(SET_NOTIFICATION_COUNT, count);
        return count;
    },
    [ADD_TO_CART](context, payload) {
        let cartItems = payload
        context.commit(SET_CART, cartItems);
        return cartItems;
    },
    [UPDATE_CART](context, payload) {
        let cartItems = payload
        context.commit(SET_CART, cartItems);
        return cartItems;
    },
    [EMPTY_CART](context, payload) {
        let cartItems = []
        context.commit(SET_CART, cartItems);
        return cartItems;
    }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_AUTH](state, user) {
        state.isAuthenticated = true;
        state.user = user;
        state.errors = {};
        JwtService.saveToken(user.token);
        state.isFrontendAuthenticated = false;
        state.frontendUser = [];
        state.errors = [];
        state.userNotificationCount = user.notificationCount
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = [];
        state.errors = [];
        state.userNotificationCount = ""
    },
    [SET_NOTIFICATION_COUNT](state, count) {
        state.userNotificationCount = count;
    },
    [SET_CART](state, cartItems) {
        state.cart = cartItems;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
